export enum DeliveryType {
  EXPRESS = "express",
  SCHEDULED = "scheduled",
}
